var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEstatement = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41099 0.962596H14.7723C14.8488 0.962596 14.9248 0.967485 15.0003 0.977262C17.9968 1.18681 20.3235 3.67352 20.3336 6.67726V15.2492C20.3226 18.412 17.7524 20.9685 14.5896 20.9626H7.41099C4.24767 20.9685 1.67729 18.4112 1.66699 15.2479V6.67726C1.67729 3.51395 4.24767 0.956694 7.41099 0.962596Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3336 7.42723C20.7479 7.42723 21.0836 7.09144 21.0836 6.67723C21.0836 6.26301 20.7479 5.92723 20.3336 5.92723V7.42723ZM15.0003 6.67723H14.2503C14.2503 7.09144 14.5861 7.42723 15.0003 7.42723V6.67723ZM15.7503 0.977234C15.7503 0.56302 15.4145 0.227234 15.0003 0.227234C14.5861 0.227234 14.2503 0.56302 14.2503 0.977234H15.7503ZM9.66699 16.3792C10.0812 16.3792 10.417 16.0435 10.417 15.6292C10.417 15.215 10.0812 14.8792 9.66699 14.8792V16.3792ZM5.667 14.8792C5.25278 14.8792 4.917 15.215 4.917 15.6292C4.917 16.0435 5.25278 16.3792 5.667 16.3792V14.8792ZM15.0003 12.3792C15.4145 12.3792 15.7503 12.0435 15.7503 11.6292C15.7503 11.215 15.4145 10.8792 15.0003 10.8792V12.3792ZM5.667 10.8792C5.25278 10.8792 4.917 11.215 4.917 11.6292C4.917 12.0435 5.25278 12.3792 5.667 12.3792V10.8792ZM20.3336 5.92723H15.0003V7.42723H20.3336V5.92723ZM15.7503 6.67723V0.977234H14.2503V6.67723H15.7503ZM9.66699 14.8792H5.667V16.3792H9.66699V14.8792ZM15.0003 10.8792H5.667V12.3792H15.0003V10.8792Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEstatement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/estatement.06e14d70e7657c2a05eeb52f45196b1a.svg";